import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DpfService } from 'src/app/core/services/dpf.service';

@Component({
    selector: 'app-verify-otp-modal',
    templateUrl: './verify-otp-modal.component.html',
    styleUrls: ['./verify-otp-modal.component.scss'],
})
export class VerifyOtpModalComponent implements OnInit {
    @Output() back = new EventEmitter<void>();
    @Output() closed = new EventEmitter<void>();
    @Output() showLogin = new EventEmitter<void>();

    otp: string[] = ['', '', '', '', '', ''];
    otpBoxes = Array(6);
    timer = 45000; // 45s
    canResend = false;
    intervalId: any;

    email = sessionStorage.getItem('email');
    otpSuccess = false;

    constructor(private dpfService: DpfService) {}

    ngOnInit() {
        this.startTimer();
    }

    active = false;
    onInput(event: any, index: number) {
        const input = event.target.value;
        if (input && index < 5) {
            const next = event.target.nextElementSibling;
            if (next) next.focus();
        }
        if (this.otp.join('').length == 6 && index == 5) {
            this.active = true;
            this.verifyOtp();
        }
    }

    onBackspace(event: any, index: number) {
        if (!this.otp[index] && index > 0) {
            const prev = event.target.previousElementSibling;
            if (prev) prev.focus();
        }
    }

    verifyOtp() {
        const otpCode = this.otp.join('');
        if (otpCode.length == 6) {
            let body = {
                email: this.email,
                otp: otpCode,
                type: 'EMAIL',
            };
            this.dpfService.verifyOtp(body).subscribe((val) => {
                if (val?.status) {
                    this.otpSuccess = true;
                }
            });
        }
    }

    startTimer() {
        this.canResend = false;
        this.timer = 45000;
        this.intervalId = setInterval(() => {
            this.timer -= 1000;
            if (this.timer <= 0) {
                this.canResend = true;
                clearInterval(this.intervalId);
            }
        }, 1000);
    }

    resendEmail() {
        let param = {
            email: this.email,
            type: 'EMAIL',
        };
        this.dpfService.resendOtp(param).subscribe((val) => {
            if (val?.status) {
                this.startTimer();
            }
        });
    }

    close() {
        // Đóng modal
    }

    goBack() {
        this.closed.emit();
        this.back.emit();
    }

    login() {
        this.closed.emit();
        this.showLogin.emit();
    }
}
